import { IconButton, Modal, styled, Typography } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthenticated } from '../../auth';
import { ImageModal } from '../../components/image-modal';
import { VideoModal } from '../../components/video-modal';
import { usePromise } from '../../hooks/use-promise';
import { getSignedUrl } from '../../util';
import { Icon } from '../icons';
import { dataRowModalStyles } from './data-row-modal.styles';

interface MediaModal {
  fileName?: string;
  handleClose: () => void;
  open: boolean;
  url: string;
}

const StyledModal = styled(Modal)({
  zIndex: 1400,
});

export const DataImageModal: FC<MediaModal> = ({ fileName, handleClose, open, url }) => {
  const { restClient } = useAuthenticated();
  const { t } = useTranslation(['common']);
  const { classes } = dataRowModalStyles();

  const [signedImageUrl, signedImageUrlError, signedImageUrlState] = usePromise(async () => {
    const result = await getSignedUrl(restClient, url);
    return result.signedUrl;
  }, [restClient, url]);

  if (signedImageUrlState === 'pending') return <></>;

  if (signedImageUrlError || !signedImageUrl) {
    return (
      <StyledModal disablePortal open={open} onClose={handleClose} >
        <Box className={classes.imageBox}>
          <Typography
            className={classes.errorText}
            variant="caption"
          >
            {t('common:component.static-data.hint.image-modal-error')}
          </Typography>
          <IconButton
            aria-label={t('common:common.action.close')}
            className={classes.closeButton}
            onClick={handleClose}
          >
            <Icon icon="X" />
          </IconButton>
        </Box>
      </StyledModal>
    );
  }

  return (
    <ImageModal
      fileName={fileName}
      handleClose={handleClose}
      image={signedImageUrl}
      open={open}
    />
  );
};

export const DataVideoModal: FC<MediaModal> = ({ fileName, handleClose, open, url }) => {
  return (
    <VideoModal
      fileName={fileName}
      handleClose={handleClose}
      open={open}
      url={url}
    />
  );
};
